<button #fab
        type="button"
        class="chat-fab"
        (pointerdown)="onPointerDown($event)"
        (keydown)="onKey($event)"
        [attr.aria-label]="'chatAi.fab.tooltip' | translate"
        [title]="'chatAi.fab.tooltip' | translate">
  <svg class="chat-fab__icon" aria-hidden="true" width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 3.5C2 2.67157 2.67157 2 3.5 2H12.5C13.3284 2 14 2.67157 14 3.5V9.5C14 10.3284 13.3284 11 12.5 11H9L6 14V11H3.5C2.67157 11 2 10.3284 2 9.5V3.5Z" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  <span class="chat-fab__label">{{ 'chatAi.fab.label' | translate }}</span>
</button>
